import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { TermsAndConditionsView } from 'views/membership-module/TermsAndConditionsView';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import { HydrationWrapper } from 'views/common/components';
import { membershipTCQuery } from 'views/membership-module/TermsAndConditionsView/utils/membershipTCQuery';
import { cmsServerFetch } from 'lib/utils/cmsServerFetch';

const TermsAndConditionsPage = (props) => {
  const { serverData } = props;
  return (
    <HydrationWrapper>
      <TermsAndConditionsView serverData={serverData?.seo_values} />
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const { locale } = ctx;

  let serverError = null;
  let layoutData = null;
  let serverData = null;
  let cmsData = null;
  const ssrRender = isCrawlers(ctx.req.headers['user-agent']);
  if (ssrRender) {
    const [layoutRes, seoValuesRes, cmsDataRes] = await Promise.all([
      serverFetch(ctx, API.layout, ctx.query),
      serverFetch(ctx, API.seoValues),
      cmsServerFetch(ctx, membershipTCQuery),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
      if (seoValuesRes.success && seoValuesRes.data) {
        serverData = { seo_values: seoValuesRes.data };
      } else {
        serverError = {
          statusCode: seoValuesRes.error.response.status,
        };
      }
    } else {
      serverError = {
        statusCode: layoutRes.error.response.status,
      };
    }
    if (cmsDataRes?.success) {
      cmsData = cmsDataRes.cmsData;
    } else {
      serverError = {
        statusCode: 500,
      };
    }
  } else {
    const cmsDataRes = await cmsServerFetch(ctx, membershipTCQuery);
    if (cmsDataRes?.success) {
      cmsData = cmsDataRes.cmsData;
    } else {
      serverError = {
        statusCode: 500,
      };
    }
  }

  const hreflangData = generateHreflang(
    PATHS.membership.termsAndConditions().url,
    locale,
  );
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_terms_and_conditions_page',
        'fe_er_common_main_widget',
      ])),
      hreflangData,
      serverData,
      layoutData,
      serverError,
      ssrRender,
      cmsData,
    },
  };
}

export default TermsAndConditionsPage;
